<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="所属班级名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请输入所属班级名称"
                v-model="queryParam.classId"
                dict="school_class,name,id,delete_flag=0"
                :async="true"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="请选择发布状态">
              <j-dict-select-tag
                v-model="queryParam.publishStatus"
                placeholder="请选择"
                dictCode="publish_status"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('校园动态表')">
        导出
      </a-button>
      <a-upload
        name="file"
        :showUploadList="false"
        :multiple="false"
        :headers="tokenHeader"
        :action="importExcelUrl"
        @change="handleImportExcel"
      >
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <template slot="picUrl" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="80px"
            alt
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button v-else :ghost="true" type="primary" size="small" @click="preview(text)">
            预览视频
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="publish(record)">发布</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <SchoolActivityVideo ref="carLocation"></SchoolActivityVideo>
    <schoolActivity-modal ref="modalForm" @ok="modalFormOk"></schoolActivity-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import SchoolActivityModal from './modules/SchoolActivityModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { httpAction } from '@api/manage'
import { getAction, postAction, postActions } from '../../../api/manage'
import { message } from 'ant-design-vue'
import { defineComponent } from 'vue'
import SchoolActivityVideo from './modules/SchoolActivityVideo'

export default {
  name: 'SchoolActivityList',
  mixins: [JeecgListMixin],
  components: {
    SchoolActivityModal,
    JSearchSelectTag,
    SchoolActivityVideo,
  },
  data() {
    return {
      description: '校园动态表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级名称',
          align: 'center',
          dataIndex: 'classId_dictText',
        },
        {
          title: '活动内容',
          align: 'center',
          dataIndex: 'content',
          customRender: (_, record) => {
            return record.content.length >= 25 ? (
              <a-tooltip>
                <template slot="title">{record.content}</template>
                {record.content.substring(0, 25) + '...'}
              </a-tooltip>
            ) : (
              record.content
            )
          },
        },
        {
          title: '活动图片地址',
          align: 'center',
          dataIndex: 'picUrl',
          scopedSlots: { customRender: 'picUrl' },
        },
        {
          title: '活动视频地址',
          align: 'center',
          dataIndex: 'videoUrl',
          scopedSlots: { customRender: 'fileSlot' },
        },
        {
          title: '是否给家长可见',
          align: 'center',
          dataIndex: 'visible_dictText',
        },
        {
          title: '发布状态',
          align: 'center',
          dataIndex: 'publishStatus_dictText',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/aigoes/schoolActivity/list',
        delete: '/aigoes/schoolActivity/delete',
        deleteBatch: '/aigoes/schoolActivity/deleteBatch',
        exportXlsUrl: 'aigoes/schoolActivity/exportXls',
        importExcelUrl: 'aigoes/schoolActivity/importExcel',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  mounted() {
    // 初始化 Video.js 播放器
    this.player = videojs(this.$refs.myVideo, {
      // 设置播放器的选项，可根据需要进行配置
    })
  },
  beforeDestroy() {
    // 销毁 Video.js 播放器
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    publish(record) {
      let params = {
        id: record.id,
        publishStatus: 1,
      }
      console.log(params)
      postAction('/aigoes/schoolActivity/edit', params).then((res) => {
        message.success({ content: '发布成功!', duration: 1 })
        console.log(res)
        this.loadData()
      })
    },
    preview(video) {
      console.log(video)
      this.$refs.carLocation.edit(video)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
